import { Box } from '@chakra-ui/react';
import { Feature } from '@features';
import { LucideProps } from 'lucide-react';
import { RtaIconButton, RtaIconButtonProps } from './rta-icon-button';

export type RtaFeatureIconButtonProps = Partial<RtaIconButtonProps> & {
	feature: Feature<any>;
	iconProps?: LucideProps;
};

export const RtaFeatureIconButton = (props: RtaFeatureIconButtonProps) => {
	const { feature, iconProps = {}, ...rest } = props;

	const button = <RtaIconButton
		{...rest}
		icon={feature.icon(iconProps)}
		onClick={feature.handler}
		enabled={!feature.disabled}
		hidden={feature.hidden}
		label={feature.tooltip}
	/>;

	if (!feature.indicator || feature.hidden) return button;

	return <Box position="relative" display="inline-flex">
		{button}
		<Box
			position="absolute"
			top="2px"
			right="2px"
			w="9px"
			h="9px"
			bg="orange.400"
			borderRadius="full"
			border="2px solid"
			borderColor="white"
			pointerEvents="none"
		/>
	</Box>;
};
